import React from "react";
import PropTypes from "prop-types";
import { Tile } from "../ui";

function makeList(number) {
  const List = [];
  for (let index = 0; index < number; index++) {
    List.push(<Tile key={index} />);
  }
  return List;
}

const TileList = ({ number }) => {
  const list = makeList(number);
  return <>{list.map(item => item)}</>;
};

TileList.propTypes = {
  number: PropTypes.number.isRequired
};

export default TileList;
